/**
 * @generated SignedSource<<6db2ae0852c00b930afca16a24ed5c86>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ResetStreamsInput = {
  stakeholderId: string;
};
export type stakeholderRow_StakeholderRowResetStreamsMutation$variables = {
  input: ResetStreamsInput;
};
export type stakeholderRow_StakeholderRowResetStreamsMutation$data = {
  readonly resetStreams: {
    readonly stakeholder: {
      readonly id: string;
      readonly streams: ReadonlyArray<{
        readonly createdAt: any;
        readonly flows: ReadonlyArray<{
          readonly amount: number;
          readonly date: any | null | undefined;
          readonly kind: string;
        }>;
        readonly id: string;
        readonly morph: {
          readonly id: string;
          readonly kind: string;
        };
      }>;
    };
  } | null | undefined;
};
export type stakeholderRow_StakeholderRowResetStreamsMutation = {
  response: stakeholderRow_StakeholderRowResetStreamsMutation$data;
  variables: stakeholderRow_StakeholderRowResetStreamsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Morph",
  "kind": "LinkedField",
  "name": "morph",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "stakeholderRow_StakeholderRowResetStreamsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ResetStreamsMutationPayload",
        "kind": "LinkedField",
        "name": "resetStreams",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Stakeholder",
            "kind": "LinkedField",
            "name": "stakeholder",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Stream",
                "kind": "LinkedField",
                "name": "streams",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Flow",
                    "kind": "LinkedField",
                    "name": "flows",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      (v3/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "stakeholderRow_StakeholderRowResetStreamsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ResetStreamsMutationPayload",
        "kind": "LinkedField",
        "name": "resetStreams",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Stakeholder",
            "kind": "LinkedField",
            "name": "stakeholder",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Stream",
                "kind": "LinkedField",
                "name": "streams",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Flow",
                    "kind": "LinkedField",
                    "name": "flows",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      (v3/*: any*/),
                      (v6/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7bf0346f335886a23d8c028e38d2c8f0",
    "id": null,
    "metadata": {},
    "name": "stakeholderRow_StakeholderRowResetStreamsMutation",
    "operationKind": "mutation",
    "text": "mutation stakeholderRow_StakeholderRowResetStreamsMutation(\n  $input: ResetStreamsInput!\n) {\n  resetStreams(input: $input) {\n    stakeholder {\n      id\n      streams {\n        id\n        morph {\n          id\n          kind\n        }\n        flows {\n          amount\n          kind\n          date\n          id\n        }\n        createdAt\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f603be3d3eb6a91ea98f994e429dc841";

export default node;
